export const UDEMY_MASTER_SERVICES_AGREEMENT_URL = 'https://www.udemy.com/terms/ub/';

export const UDEMY_BUSINESS_PRIVACY_STATEMENT_URL = 'https://www.udemy.com/terms/ub-privacy/';
